import React from 'react';
import "./Subtotal.css";
import CurrencyFormat from 'react-currency-format';
import {useStateValue} from "./StateProvider";
import {getBasketTotal} from "./reducer";
import {useNavigate} from "react-router-dom";
import StripeCheckout from "react-stripe-checkout";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import {toast} from "react-toastify";


function Subtotal() {
    const Navigate = useNavigate();
    const [{basket, user}, dispatch] = useStateValue();
    const total = getBasketTotal(basket);

    async function handleToken(token){
        const response = await axios.post("http://localhost:8080/checkout", {
            token, 
            total
        })
        const {status} = response.data;
        if(status === "success"){
            toast("Success! Product Purchased", {
                type: "success"
            })
        }else{
            toast("Error! Something went wrong", {
                type: "error"
            })
        }
    }

  return (
    <div className='subtotal'>
        <CurrencyFormat 
            renderText={(value) => (
                <>
                    <p>
                        المجموع الكلي ({basket.length} items):
                        <strong>{value}</strong>
                    </p>  
                    <small className='subtotal_left'>
                        <input type="checkbox" />
                        يحتوي هذا الطلب على هدية
                    </small>
                </>
            )}
            decimalScale={2}
            value={getBasketTotal(basket)}
            displayType={"text"}
            thousandSeparator={true}
            prefix={"$"}
        />
        <StripeCheckout 
            stripeKey="pk_test_51RKuOaGh8FMeC9dRCY1hJN8dG6KS4kqWa3Y7A2bgsn25451ct5KoWhCRhqO8IGBPks4EcvBqqsfmxJYqdHJlDUMh00rw4sClSN"
            token={handleToken}
            amount={total}
        />
    </div>
  )
}

export default Subtotal